<template>
<div>
  <div class="workspace-header" :class="{isTpg:isTpg}">

    <div v-if="sampleOnly"
         class="workspace-header-title">
          <span v-on:click="goBack"
             class="main-route" :class="{isTpg:isTpg}">
             Samples
        </span>
       <span class="breadcrumb-caret"
             :class="{smallCaret: countLetters() > letterCountForFontShrink}">
                        <font-awesome-icon icon="caret-right"  aria-hidden="false" />
                        </span>
       {{ secondaryTitle }}
    </div>

    <div class="workspace-header-title"
         :class="{smallText: countLetters() > letterCountForFontShrink}"
         v-else>

       <a v-on:click="goBack"
             class="main-route" :class="{isTpg:isTpg}">
             Main
       </a>

       <span class="breadcrumb-caret"
             :class="{smallCaret: countLetters() > letterCountForFontShrink, isTpg:isTpg}">
             <font-awesome-icon icon="caret-right"  aria-hidden="false" />
             </span>

       <span v-if="secondaryRoute">
         <router-link :to="{ name:controllerRoute }"
                     class="primary-route" :class="{isTpg:isTpg}">
            {{ controllerTitle }}
          </router-link>
       </span>
       <span v-else>
        {{ controllerTitle }}
       </span>

       <span v-if="secondaryTitle"
             class="breadcrumb-caret"
             :class="{smallCaret: countLetters() > letterCountForFontShrink, isTpg:isTpg}">
             <font-awesome-icon icon="caret-right"  aria-hidden="false" />
             </span>

       <span v-if="tertiaryTitle && tertiaryTitle != false">
         <router-link :to="{ path:secondaryRoute }"
                     class="primary-route" :class="{isTpg:isTpg}">
              <span v-if="secondaryTitle">
                {{ secondaryTitle }}
              </span>
          </router-link>
       </span>
       <span v-else>
         <span v-if="secondaryTitle">
          {{ secondaryTitle }}
         </span>
       </span>

       <span v-if="tertiaryTitle"
             class="breadcrumb-caret"
             :class="{smallCaret: countLetters() > letterCountForFontShrink, isTpg:isTpg}">
             <font-awesome-icon icon="caret-right"  aria-hidden="false" />
             </span>

       <span v-if="tertiaryTitle">
            {{ tertiaryTitle }}
       </span>

        </div>

        <div v-if="subLinkPath" class="sublinkHolder">
          <router-link :to="{ path: subLinkPath }">
          <div class="sublinkPlusHolder">
            <span class="plusIcon"><span>+</span></span>
            </div>
            <div class="sublinkTextHolder">
            <span class="sublinkText">
            {{ subLinkText }}
            </span>
            </div>
          </router-link>
        </div>

  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      letterCountForFontShrink: 20,
    };
  },
  // mounted() {
  //   this.makeRoutes();
  // },
  methods:
        {
          // makeRoutes: function() {
          //     //var path = this.$route.path;
          //     //if (split[3]) {
          //       //this.tertiaryTitle = split[2];
          //       //this.secondaryRoute = "/" + this.controllerRoute + "/" + split[2];
          //     //}
          // },
          goBack() {
            this.$router.push('/');
          },
          capitlize(item) {
            return item[0].toUpperCase() + item.slice(1);
          },
          countLetters() {
            const str = this.controllerTitle + this.secondaryTitle + this.tertiaryTitle;
            let letters = 0;
            const alphabet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ- ';
            const ar = alphabet.split('');
            for (let i = 0; i < str.length; i++) {
              if (ar.indexOf(str[i]) > -1) {
                letters += 1;
              }
            }

            return letters;
          },
        },
  props: ['providedSecondaryTitle',
    'providedTertiaryTitle',
    'subLinkPath',
    'subLinkText',
    'sample-only',
    'is-tpg',
  ],
  computed: {
    controllerRoute() {
      const { path } = this.$route;
      const split = path.split('/');
      if (split[1]) {
        if (split[1] == 'user') {
          return 'users';
        }
        return split[1];
      }

      return false;
    },
    controllerTitle() {
      const { path } = this.$route;
      const split = path.split('/');
      let controllerName = split[1];
      if (controllerName == 'whats-on') {
        controllerName = "What's On @ Gray V";
      } else if (controllerName == 'user') {
        controllerName = 'Users';
      } else if (controllerName == 'account-details') {
        controllerName = 'Account Details';
      } else if (controllerName == 'players') {
        controllerName = 'Player Connectivity';
      } else if (controllerName == 'update_payments') {
        controllerName = 'Update Payments';
      } else {
        controllerName = this.capitlize(controllerName);
      }
      return controllerName;
    },
    secondaryRoute() {
      const { path } = this.$route;
      const split = path.split('/');
      if (split[1] == 'user') {
        return '/users';
      }
      if (split[2]) {
        return `/${split[1]}/${split[2]}`;
      }

      return false;
    },
    secondaryTitle() {
      if (this.providedSecondaryTitle && this.providedSecondaryTitle.length > 0) {
        return this.providedSecondaryTitle;
      }

      return false;
    },
    tertiaryTitle() {
      let { path } = this.$route;
      let split = path.split('/');

      if (split[1] == 'players') {
        const locationZoneID = this.$route.params.pid;
        if (locationZoneID && locationZoneID.length > 0) {
          return;
        }
      }

      if (split[1] == 'documents') {
        // return;
      }
      if (this.providedTertiaryTitle && this.providedTertiaryTitle.length > 0) {
        return this.providedTertiaryTitle;
      }
      path = this.$route.path;
      split = path.split('/');
      return split[3];
    },
  },
  updateFontSize() {

  },
};
</script>

<style>
.sublinkHolder {
  float:right;
  width:120px;
  margin-top:7px;
}
.sublinkPlusHolder {
  float:left;
  width:30px;
}
.sublinkTextHolder {
  float:left;
  width:90px;
}
.workspace-header {
  margin-top:-12px;
  height: 50px;
  width:850px;
  text-align: left;
    clear:right;
}
.workspace-header-title {
  font-size: 20px;
  text-align: left;
  padding-left:18px;
  position:absolute;
  left:30px;
  float:left;
}
.workspace-header.isTpg {
  color:black;
}
.workspace-header-title span {
}
@media screen and (max-width:1200px) {
	.workspace-header {
    margin:0 auto;
    margin-top:0px;
	}
	.workspace-header-title {
		font-size:16px;
    margin-top:15px;
    padding-left:0px;
	}
      .sublinkHolder {
      margin-top:15px;
    }
}

@media (max-width:1200px) and (min-width:768px) {
    .workspace-header {
        margin:0 auto;
        width:768px;
        margin-top:20px;
    }
    .workspace-header-title {

      float:left;
    }
    .sublinkHolder {
      margin-top:15px;
    }
}
@media (max-width:768px) {
    .workspace-header {
      margin-top:0px;
      position:relative;
        padding:10px;
        width:100%;
        margin-bottom:14px;
        font-size: 14px;
        margin-left:-20px;
    }

    .sublinkHolder {
      margin-top:15px;
    }
}

.primary-route{
  text-transform: capitalize;
  }
  .main-route {
    cursor: pointer;
  }
.breadcrumb-caret {
  margin-top:-16px;
  font-size:16px;
  padding-left:5px;
  padding-right:5px;
  color:#999;
}
.breadcrumb-caret.isTpg {
    /*color:#01ac81;*/
    color:#000;
}
.smallText {
  font-size:16px;
}
.smallCaret {
  font-size:12px;
}
.main-route:hover, .primary-route:hover {
  color:yellow;
}
.workspace-header.isTpg a {
    color:black;
}
.workspace-header.isTpg a:visited {
    color:black;
}
.workspace-header.isTpg a:hover {
    color:#01ac81;
}

</style>
